//Peticiones HTTP para temas referentes a Login y datos de usuario
import axios from 'axios';
import { AppUrls } from './Globals';
import { Config } from './Config';

export const productRequests = {}//Objeto agrupador de funciones

productRequests.ProductsRemote = () => {//Función de autenticación
  return axios.post(
    AppUrls.ProductsRemote,//url
    Config.SetParameters('', '', '', ''),//Objeto a enviar al API
    Config.ConfigNoAuth()//headers
  ).then(handleResponse)//next => actions => AuthActions
}

//desencripta y devuelve objeto de la respuesta del API
let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}
